import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import { Box } from '@material-ui/core';
//images
import AdiLogo from '../adi_logo.png';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dark: {
      margin: theme.spacing(1),
      width: "40px",
      height: "40px",
      backgroundColor: grey[400],
      borderColor: grey[100],
    },
    light: {
      margin: theme.spacing(1),
      width: "40px",
      height: "40px",
      backgroundColor: grey[100],
      borderColor: grey[300]
    },
    image: {
      width: "32px",
      height: "35px",
    },
  }),
);

const LogoAvatar = (props:any) => {
    const classes = useStyles();
    return (
        <Box className={props.dark ? classes.dark:classes.light} border={2} borderRadius="50%" display="flex" alignItems="flex-center" justifyContent="flex-end" >
            <img className={classes.image} src={AdiLogo} alt="ADI" />
        </Box>
    );
}

export default LogoAvatar;